/** @format */

// AnalysisPage.js
import React from "react";
import AnalysisChart from "../AnalysisDetail/AnalysisDetail";
import AnalysisDetail from "../AnalysisChart/AnalysisChart";
import "./AnalysisPage.css";
import Accessibility from "../Accessiblity/Accessibility";

export default function AnalysisPage() {
  return (
    <>
      <Accessibility/>
    <div className="analysis-container1">
      <div className="analysis-chart1">
        <AnalysisChart />
      </div>
      <div className="analysis-detail1">
        <AnalysisDetail />
      </div>
    </div>
    </>
      
  );
}
